import React from "react";
import { Link } from "react-router-dom";
import Can from "../../../_metronic/Can";

/**
 * Small, optional extra sections shown only for roles/permissions that
 * support them, reusing endpoints already fetched for the Reporting
 * Overview (POST /v2/asset-report/asset, GET /v2/score-card/all/list) -
 * see frontend/src/app/modules/Report/Overview for the original, more
 * detailed versions this links out to (per the brief: do not duplicate an
 * existing module, just surface a compact pointer to it).
 */
export default function RoleSpecificSections({ permissions, userRole, assetCondition, providers }) {
  const hasAssetCondition = assetCondition && (assetCondition.TtGood || assetCondition.TtBad);
  const hasProviders = Array.isArray(providers) && providers.length > 0;

  if (!hasAssetCondition && !hasProviders) return null;

  return (
    <div className="role-section-grid">
      <Can
        rules={permissions}
        userRole={userRole}
        perform="viewAssetReport"
        yes={() =>
          hasAssetCondition && (
            <div className="dashboard-panel">
              <div className="dashboard-panel__header">
                <h2 className="dashboard-panel__title">Asset condition</h2>
              </div>
              <div className="mini-condition">
                <span className="mini-condition__stat">
                  <i className="mini-condition__dot mini-condition__dot--good" aria-hidden="true" />
                  Operational <strong>{assetCondition.TtGood}</strong>
                </span>
                <span className="mini-condition__stat">
                  <i className="mini-condition__dot mini-condition__dot--bad" aria-hidden="true" />
                  Needs attention <strong>{assetCondition.TtBad}</strong>
                </span>
              </div>
              <Link to="/report/asset" className="dashboard-panel__link">
                View asset report &rarr;
              </Link>
            </div>
          )
        }
      />

      <Can
        rules={permissions}
        userRole={userRole}
        perform="viewScoreCard"
        yes={() =>
          hasProviders && (
            <div className="dashboard-panel">
              <div className="dashboard-panel__header">
                <h2 className="dashboard-panel__title">Provider performance</h2>
              </div>
              <ul className="activity-feed">
                {providers.slice(0, 4).map(p => (
                  <li className="activity-feed__item" key={p._id}>
                    <span className="activity-feed__dot" aria-hidden="true" />
                    <div className="activity-feed__body">
                      <div className="activity-feed__message">
                        {p.firstName} {p.lastName}
                      </div>
                      <div className="activity-feed__time">
                        Rating {Math.round(p.rating || 0)}% &middot; Timeliness {Math.round(p.timeliness || 0)}%
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
              <Link to="/report/score-card" className="dashboard-panel__link">
                View all providers &rarr;
              </Link>
            </div>
          )
        }
      />
    </div>
  );
}
